import * as Yup from 'yup';

export const EmailValidation = Yup.object({
  email: Yup.string().email('Verifique se o e-mail está correto, com @ e ponto').matches(/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/, 'E-mail inválido')
  .required('É necessário preencher o e-mail')
});